/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListWorkHour } from '../../models/api-response-list-work-hour';
import { WorkHour } from '../../models/work-hour';

export interface CreateOrUpdateListOfWorkHour$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany: string;
      body: Array<WorkHour>
}

export function createOrUpdateListOfWorkHour(http: HttpClient, rootUrl: string, params: CreateOrUpdateListOfWorkHour$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWorkHour>> {
  const rb = new RequestBuilder(rootUrl, createOrUpdateListOfWorkHour.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('refPhoneCompany', params.refPhoneCompany, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListWorkHour>;
    })
  );
}

createOrUpdateListOfWorkHour.PATH = '/v1/api/ui/work-hour/create-update-list/{refPhoneCompany}';
